import React, {useState} from 'react';
import {
  Modal,
  Box,
  Typography,
  TextField,
  MenuItem,
  Button,
  Stack,
  Divider,
  IconButton
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { Formik, Form, Field } from 'formik';
import * as Yup from 'yup';
import { createStyleDesign } from '../../apis/apiList/styleDesignApi';
import { useApp } from '../../context/AppContext';
import { useMessage } from '../../context/MessageContext';

// Validation schema
const FontSchema = Yup.object().shape({
  fontName: Yup.string().required('font name is required'),
  fontType: Yup.string().required('font type is required'),
  fontFile: Yup.mixed().required('font file is required')
});

const AddFont = ({ isOpen, organization, onClose, handleFileChange, updateList }) => {
    const [fontName, setFontName] = useState('');
    const [fontType, setFontType] = useState('');
    // const [file, setFile] = useState('');
    const { userDetails } = useApp();
    const [isLoading, setIsLoading] = useState(false);
    const { showMessage } = useMessage();

    const handleSubmit = async (name, type, file) =>{
        setIsLoading(true);
        const formData = new FormData();
        formData.append("name", name);
        formData.append("type", type);
        formData.append("organizationId", organization._id);
        formData.append("designType", 'font');
        formData.append("folderid", organization.boxFolderId);
        // formData.append("userId", userDetails._id);
        formData.append("file", file);
        try {
        const response = await createStyleDesign(formData, {
            headers: {
            "Content-Type": "multipart/form-data",
            "x-access-token": userDetails?.jwtToken
            },
        });
        console.log('response', response)
        if (response.success) {
            updateList(response.data?.style?.fonts || [], 'fonts', response.data?.sharedLink);
            showMessage(response.message, "success");
        }
        onClose()
        } catch (err) {
        console.error('Error uploading Font:', err);
        // Handle error (e.g., show a message to the user)
        showMessage(err?.response?.data?.message || 'Internal server issue', "error");
        } finally {
        setIsLoading(false);
        }
    }
    
    

    return (
        <Modal open={isOpen} onClose={onClose}>
        <Box
            sx={{
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                width: 500,
                bgcolor: 'background.paper',
                borderRadius: 2,
                boxShadow: 24,
                maxWidth: '90%',
            }}
        >
            <Stack direction="row" justifyContent="space-between" sx={{ px: 4, py: 2 }} alignItems='center'>
            <Typography variant="h3">Add Font</Typography>
            <IconButton onClick={onClose}>
                <CloseIcon />
            </IconButton>
            </Stack>

            <Divider />

            <Formik
            initialValues={{
                fontName: '',
                fontType: '',
                fontFile: null
            }}
            validationSchema={FontSchema}
            onSubmit={(values) => {
                setFontName(values.fontName);
                setFontType(values.fontType);
                // handleFileChange({ target: { files: [values.fontFile] } });
                // onClose();
                // setFile(values.fontFile);
                handleSubmit(values.fontName, values.fontType, values.fontFile);
            }}
            >
            {({ errors, touched, setFieldValue, values }) => (
                <Form>
                <Box display="flex" flexDirection="column" gap={2} sx={{ p: 4, pt: 3 }}>
                    {/* Logo Name */}
                    <Field
                        as={TextField}
                        name="fontName"
                        label="Font Name"
                        variant="outlined"
                        fullWidth
                        error={touched.fontName && Boolean(errors.fontName)}
                        helperText={touched.fontName && errors.fontName}
                    />

                    {/* Logo Type */}
                    <Field
                        as={TextField}
                        select
                        name="fontType"
                        label="Select Font Type"
                        variant="outlined"
                        fullWidth
                        error={touched.fontType && Boolean(errors.fontType)}
                        helperText={touched.fontType && errors.fontType}
                    >
                        <MenuItem value="" disabled>Select Font Type</MenuItem>
                        <MenuItem value="primary">Primary</MenuItem>
                        <MenuItem value="secondary">Secondary</MenuItem>
                    </Field>

                    {/* Upload Logo */}
                    <Box>
                    <Typography variant="subtitle1" fontWeight={500} mb={1}>
                        Upload Font:
                    </Typography>
                    <Box display="flex" alignItems="center" gap={1}>
                        <Button
                        variant="outlined"
                        component="label"
                        sx={{ bgcolor: '#f9fafb', borderColor: '#d1d5db' }}
                        >
                        Choose File
                        <input
                            type="file"
                            hidden
                            accept="image/*"
                            onChange={(event) => {
                            setFieldValue('fontFile', event.currentTarget.files[0]);
                            }}
                        />
                        </Button>
                        <Typography variant="body2" color="text.secondary">
                        {values.fontFile?.name || 'No file selected'}
                        </Typography>
                    </Box>
                    {touched.fontFile && errors.fontFile && (
                        <Typography variant="caption" color="error">
                        {errors.fontFile}
                        </Typography>
                    )}
                    </Box>

                    {/* Save Button */}
                    <Box display="flex" justifyContent="flex-end" mt={2}>
                    <Button type="submit" variant="contained" disabled={isLoading}>
                        {isLoading ? "Saving..." : "Save Changes"}
                    </Button>
                    </Box>
                </Box>
                </Form>
            )}
            </Formik>
        </Box>
        </Modal>
    );
};

export default AddFont;
